import React,{useState} from "react";
import Header from "../../layout/Header";
import Accordion from "react-bootstrap/Accordion";
import { Loader } from "../../loader";
import { useTranslation } from "react-i18next";
 
export const TransactionDetails = () => {
  const { t, i18n } = useTranslation();

const [loading, setLoading] = useState(false);
  return (
    <>
      <Header />
      <div className="main">
      <Accordion.Header>{t("ReferenceId")} - 6589999
      <span className="float-end">₹125.00</span>
      </Accordion.Header> 
        <div className="container">
        {loading && (
           <Loader />
          )} 
          <div className="d-flex flex-column gap-4">
            <div className="card">
              <div className="card-body p-2" style={{fontSize:'.9rem'}}> 
                <p className="mb-2">
                  <span className="claimList-heading">
                    {/* उत्पादनाचे नांव */}
                    {t("productName")}
                    </span>:
                  PEXALON
                </p>
                <p className="mb-2">
                  <span className="claimList-heading"> 
                  {t("reward")}
                  </span>: ₹ 37.50
                </p>
                <p className="mb-2">
                  <span className="claimList-heading">   
                   {t("serialNO")}
                </span>: 77777777
                </p>
                <p className="mb-2">
                  <span className="claimList-heading">         
                            {t("status")}
                    </span>:
                  SUCCESS
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
